<template>
  <v-dialog v-model="visible" persistent :max-width="width">
    <v-card>
      <v-card-title class="headline">
        檔案上傳
      </v-card-title>
      <v-card-text>
        <v-layout  row wrap style="margin-left: 0;">
          <v-flex>
            <div class="dropbox">
              <input type="file" ref="file" multiple :name="uploadFieldName"
                     @change="filesChange($event.target.name, $event.target.files);"
                     accept="image/*,.pdf" class="input-file">
              <p>
                將圖片或PDF拖到此處<br> 或點擊上傳
              </p>
            </div>
          </v-flex>
        </v-layout>

        <v-layout v-if="uploadedFiles && uploadedFiles.length > 0">
          <v-flex md6
            class="margin-bottom"
            v-for="(file, index) in uploadedFiles"
            :key="`${file.name}_${index}`">
            <div class="imgBox" :key="`${file.name}_${index}`">
              <img class="image-view" v-if="file.name.toLowerCase().indexOf('.pdf') === -1 && file.name.toLowerCase().indexOf('.zip') === -1" :src="file.image" />
              <v-layout>
                <v-flex md8 style="padding-left: 0.5rem; ">
                  <span class="image-title">{{file.name}}</span>
                </v-flex>
                <v-flex md4>
                  <v-btn type="danger" size="small" style="margin: 5px;"
                         @click="removeUploadImage(file.name)">刪除</v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>

        <v-card-actions>
          <v-btn class="danger" dark text @click="cancel">關閉</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="primary" dark text :loading="saveLoading" @click="save">上傳</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import MobileDetect from 'mobile-detect';
const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: 'UploadDialog',
  props:{
    visible: Boolean,
    caseId: String,
  },
  data() {
    return {
      width: md.phone() ? "80%" : "50%",
      uploadedFiles: [],
      uploadFieldName: 'photos',
      imageInfo: {
        imageName: '',
        sort: 0,
      },
      saveLoading: false,
      loadingText: '上傳中...',
      imgUrl: 'http://fakeimg.pl/350x200/?text=Loading&font=lobster',
      count: 0,
      imageList: [],
    };
  },
  created() {
    this.uploadedFiles = [];
    this.uploadFieldName = 'photos';
  },
  methods: {
    ...mapActions(['updateData', 'getImageUrl', 'removeData', 'uploadImageData', 'saveFinanceCreditData', 'saveAttachmentFile' ]),
    reset(){
      this.uploadedFiles = [];
      this.imageList = [];
      this.saveLoading = false;
      this.$refs.file.value = null;
    },
    filesChange(fieldName, fileList) {
      console.log(fieldName);
      const files = Object.values(this.$refs.file.files);
      console.log('== files4 ==');

      console.log(fileList.length);
      console.log(files);
      console.log('== files5 ==');
      // handle file changes
      const formData = new FormData();
      if (!fileList.length) return;

      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        // eslint-disable-next-line
        .map((i ,x) => {
          formData.append(fieldName, fileList[x], fileList[x].name);

          const file = { name: fileList[x].name, image: fileList[x],
            size: fileList[x].size, type: fileList[x].type };

          this.createImage(i, file , fileList.length - 1);
        });
    },
    createImage(i , file, total) {
      console.log('== files6 ==');
      const reader = new FileReader();
      const fileName = file.name;
      console.log(`=== createImage fileName === ${fileName} `);
      reader.onload = (e) => {
        const image = e.target.result;
        console.log(`=== createImage === \n ${image}`);
        const filItem = { name:fileName, image };
        console.log(`=== createImage === `);
        this.uploadedFiles.push(filItem);
        console.log(`=== uploadedFiles === ${this.uploadedFiles.length}`);
      };
      reader.readAsDataURL(file.image);
    },
    removeUploadImage(imgName) {
      this.uploadedFiles.forEach((item, index) => {
        if (item.name === imgName) {
          this.uploadedFiles.splice(index, 1);
        }
      });
    },
    getFileType(type) {
      const name = type.toLowerCase();
      if (name.indexOf('jpeg') > -1 || name.indexOf('jpg') > -1) {
        return 'jpg';
      }
      if (name.indexOf('png') > -1) {
        return 'png';
      }
      if (name.indexOf('pdf') > -1) {
        return 'pdf';
      }
      return 'zip';
    },
    cancel(){
      this.visible = false;
      this.$emit('cancelUpload');
    },
    async save() {
      this.loadingText = '上傳中...';
      this.saveLoading = true;
      console.log(`this.uploadedFiles.length === ${this.uploadedFiles.length}`);
      if (this.uploadedFiles && this.uploadedFiles.length > 0) { // 是否有圖片要上傳
        this.saveLoading = true;
        let uploadCount = 0;

        this.uploadedFiles.forEach((item) => {
          // console.log(`user === ${this.itemDetail.caseId} image = ${item.image}`);
          const path = `${this.caseId}/${item.name}`;
          this.$store.dispatch('uploadImageData', {
            name: `caseImages/${path}`,
            image: item.image,
          }).then((response) => {
            console.log(`uploadImageData success ${JSON.stringify(response)}`);
            uploadCount += 1;

            // 加入新圖資料
            if (!this.imageList) {
              this.imageList = [];
              const newImage = { imageName: item.name,
                type: this.uploadType,
                sort: 0,
                data: response };
              this.imageList.push(newImage);
            } else {
              const newImage = { imageName: item.name,
                type: this.uploadType,
                sort: this.imageList.length,
                data: response };
              this.imageList.push(newImage);
            }
            // 處理完成更新資料
            if (this.uploadedFiles.length === uploadCount) {
              console.log(JSON.stringify(this.imageList));
              const result = this.imageList[0];
              this.finish(result.data);
              this.resultFullData(this.imageList);
              this.reset();
            }
          }, (error) => {
            console.log(`uploadImageData error ${JSON.stringify(error)}`);
            uploadCount += 1;
            if (this.uploadedFiles.length === uploadCount) {
              this.saveLoading = false;
            }
          });
        });
      } else {

      }
    },
    finish(url){
      this.saveLoading = false;
      this.$emit('uploadFinish', url);
    },
    resultFullData(result){
      this.saveLoading = false;
      this.$emit('resultFullData', result);
    }
  }
};
</script>

<style scoped>
.imgBox {
  box-shadow: 4px 4px 12px -2px rgba(20%,20%,40%,0.5);

}

.image-view {
  width: 100%;
  height: 180px;
  object-fit: scale-down;
}

.image-title {

  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
  overflow: hidden
}


.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: white;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadDialog.vue